module.exports = __webpack_public_path__ + "static/elephant10-34e9491560102db1481a830a5174e557.jpeg";